
import { Slider } from 'vue-color';
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

// const tinycolor = require('tinycolor2');

@Component({
  extends: Slider,
})
export default class SliderColorComponent extends Vue<Slider> {
  @Prop()
  private color?: { hsl: string };

  @Prop({ default: () => ['.80', '.65', '.50', '.35', '.20'] })
  private swatches!: Array<string>;

  constructor() {
    super();
  }

  mounted() {
    if (this.color) {
      (this as any).colorChange(this.color);
    }
  }

  hueChange(data: any) {
    (this as any).colorChange(data);
    return this.onColorChange(data);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  handleSwClick(index: number, offset: number) {
    return false;
  }

  @Emit()
  onColorChange({ h }: { h: number }) {
    return this.swatches.map((percentage) => `hsl(${h}, 50%, ${Number(percentage) * 100}%)`);
  }
}
